import { render, staticRenderFns } from "./AdditionalFiltersHotel.vue?vue&type=template&id=23197d52&"
import script from "./AdditionalFiltersHotel.vue?vue&type=script&lang=ts&"
export * from "./AdditionalFiltersHotel.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalFiltersHotel.vue?vue&type=style&index=0&id=23197d52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports